import { useParams } from "react-router-dom";
import { Lookbook } from "@/components/landing/Lookbook";
import { Footer } from "@/components/landing/Footer";
import { PurchasePopup } from "@/components/landing/PurchasePopup";
import { PageHeader } from "@/components/landing/PageHeader";
import { PalestineCounter } from "@/components/landing/PalestineCounter";

export default function Shop() {
  const { category } = useParams();
  const valid = category || "all";
  return (
    <main data-testid="shop-page" className="bg-[#ffffff] text-[#0a0a0b] min-h-screen antialiased">
      <PageHeader page="shop" link={{ id: "about", to: "/about", label: "About" }} />
      <div className="pt-16">
        {valid === "palestine" && (
          <div className="relative z-10 bg-[#f3f2ec] pt-10 sm:pt-14 -mb-12 sm:-mb-16">
            <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
              <PalestineCounter variant="light" testId="palestine-counter-shop" />
            </div>
          </div>
        )}
        <Lookbook key={valid} initialCategory={valid} />
      </div>
      <Footer />
      <PurchasePopup />
    </main>
  );
}
